export default "/images/vendor/flag-icons/flags/1x1/my.svg?579b190bdbd98b3ff45b28e2a35dc6fa";